import { UserContextContext } from '@repo/ui/UserContext';
import { useContext } from 'react';

export const useUser = () => {
  const user = useContext(UserContextContext);
  if (!user) {
    throw new Error('Trying to access user outside of the <UserContext>');
  }
  return user;
};
